<template>
  <div class="uiwu">
      <div class="uiwu-box">
          <ul class="uiwu-flex">
              <li>
                  <img src="../../assets/home/pc/address.png" alt="">
                  <div>
                      <p>地址</p>
                      <p>湖南省长沙高新开发区文轩路27号麓谷企业广场C2栋七楼</p>
                      
                  </div>
              </li>
              <li>
                  <img src="../../assets/home/pc/018.png" alt="">
                  <div>
                      <p>电话</p>
                      <p>0731-88905650</p>
                  </div>
              </li>
              <li>
                  <img src="../../assets/home/pc/QQ.png" alt="">
                  <div>
                      <p>网联</p>
                      <p>QQ 904649296</p>
                  </div>
              </li>
          </ul>
      </div>
      <!--  -->
      <p>Copyright © 2022 湖南艾尼科技有限公司版权所有 湘ICP备11013775号-1  </p>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
    .uiwu{
        background: #2F2F32;
        min-height: 227px;
        overflow: hidden;
        
         @media screen and (min-width:320px) and (max-width:767px) {
             min-height: 5.7067rem;
             padding-bottom: .1333rem;
             >p{
                 
                 font-size: .2667rem !important;
                 line-height: 1.5 !important;
                 display: flex;
                 align-items: center;
                 padding: .3rem .4rem !important;
             }
         }
        &-box{
            ul{
                align-items: center;
                justify-content: center;
                height: 170px;
                box-sizing: content-box;
                padding-top: 30px;
                padding: 0 10px;
                li{
                    flex: 1;
                    display: flex;
                    // align-items: center;
                    justify-content: center;
                    height: 73px;
                    img{
                        margin-right: 15px;
                        width: auto;
                        height: 53px;
                    }
                    p{
                        font-size: 16px;
                        font-weight: 400;
                        color: #999999;
                        &:nth-child(1){
                            margin-bottom: 10px;
                        }
                        span{
                            display: block;
                        }
                    }
                }
                @media screen and (min-width:320px) and (max-width:767px) {
                     flex-direction: column;
                     justify-content: flex-start;
                     align-items: flex-start;
                     padding: 0;
                     height: auto;
                     padding-top: .2rem;
                     li{
                         width: 100%;
                         justify-content: flex-start;
                         padding: .3rem .4rem;
                        //  border-bottom: 1px solid rgba(255,255,255,.1);
                         img{
                             width: auto;
                             height: .7067rem;
                         }
                         p{
                            //  white-space: nowrap;
                             font-size: .4267rem;
                             &:nth-child(1){
                                margin-bottom: .1333rem;
                                font-size: .32rem;
                             }
                             &:nth-child(2){
                                 font-size: .32rem;
                             }
                             span{
                                 display: inline;
                             }
                         }
                     }
                 }
            }
        }
        >p{
                text-align: center;
                line-height: 56px;
                font-size: 16px;
                font-weight: 400;
                color: #666666;
                // border-top: 1px solid rgba(255,255,255,.1);
                // white-space: nowrap;
                padding: 0 .4rem;
                padding-bottom: 30px;
            }
    }
</style>